import React, {useEffect, useState} from "react";
import {useFormik} from "formik";
// import * as Yup from "yup";
import closeIcon from "../../img/closeIcon.svg";
import addPlusIcon from "../../img/addPlusBlueIcon.svg";
import minusIcon from "../../img/iconMinus.svg";
import RoutingInstruction from "./RoutingInstruction/RoutingInstruction";
import CargoDeclaration from "./CargoDeclaration/CargoDeclaration";
import GrossWeight from "./GrossWeight/GrossWeight";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import {axiosDeleteGoods} from "../../Api/ApiRouteOrder/axiosDeleteGoods";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";

const RouteOrderModal = (props) => {

    const {
        isRouteOrdersBodyRequest,
        onHandleRouteOrder,
        onCloseRouteOrderModal
    } = props

   
    const axiosPrivate = useAxiosPrivate();
    const { getRequestDataToggle } = useAuth();
    const [isGrossWeightType, setIsGrossWeightType] = useState('KGS');

    const optionGrossWeight = [
        {value: 'KGS'},
        {value: 'SQ_M'},
        {value: 'TN'},
        {value: 'PIECES'},
        {value: 'CBM'}
    ]

    function idGenerate(arr) {
        if (arr.length < 1) {
            return 1;
        } else {
            const allIdArray = arr.map((arr) => {
                return arr.id;
            });
            return Math.max(...allIdArray) + 1;
        }
    }

    const formik = useFormik({
        initialValues: {
            id: isRouteOrdersBodyRequest.length !== 0 ? isRouteOrdersBodyRequest[0]?.id : null,
            number: isRouteOrdersBodyRequest.length !== 0 ? isRouteOrdersBodyRequest[0]?.number : '',
            date: isRouteOrdersBodyRequest.length !== 0 ? isRouteOrdersBodyRequest[0]?.date : '',
            goods: isRouteOrdersBodyRequest.length !== 0 && isRouteOrdersBodyRequest[0]?.goods.length !== 0? isRouteOrdersBodyRequest[0]?.goods : [],
            unitsType: isRouteOrdersBodyRequest.length !== 0 ? isRouteOrdersBodyRequest[0]?.unitsType : isGrossWeightType
        },
        // validationSchema: Yup.object({
        //     number: Yup.string()
        //         .required('Required field!'),
        //     date: Yup.string()
        //         .required('Required field!'),
        //     importVGTD: Yup.string()
        //         .required('Required field!'),
        //     exportVGTD: Yup.string()
        //         .required('Required field!'),
        //     grossWeight: Yup.number()
        //         .required('Required field!'),
        // }),
        onSubmit: values => onHandleRouteOrder(isRouteOrdersBodyRequest.length !== 0 ? { isEdit: true, values: values } : { isEdit: false, values: values })
    })

    const onHandleGrossWeightType = (value) => {
        setIsGrossWeightType(value)
        formik.setFieldValue('unitsType', value)
    }

    const onHandlerAddGoods = () => {
        const itemGoods = {
            id: idGenerate(formik.values.goods),
            exportVGTD: "",
            importVGTD: "",
            grossWeight: 0,
            newGoods: true
        }
        formik.setFieldValue('goods', [...formik.values.goods, itemGoods])
    }

    const onHandlerDeleteGoods = (goodId) => {
        if(goodId.newGoods) {
            const filterDeleteGoods = formik.values.goods.filter(el => el.id !== goodId.id)
            formik.setFieldValue('goods', filterDeleteGoods)
        } else {
            axiosDeleteGoods(axiosPrivate, goodId.id, getRequestDataToggle);
            const filterDeleteGoods = formik.values.goods.filter(el => el.id !== goodId.id)
            formik.setFieldValue('goods', filterDeleteGoods)
        }
    }

    return (
        <div className="route-order-modal__container">
            <form onSubmit={formik.handleSubmit} className="route-order-modal">
                <div className="route-order-modal__title">
                    <div className="route-order-modal__title-status">
                        <h3>Loading order {isRouteOrdersBodyRequest[0]?.number ? `№${isRouteOrdersBodyRequest[0]?.number}` : ''}</h3>
                    </div>
                    <img onClick={() => onCloseRouteOrderModal()} className='route-order-modal__title-image-close' src={closeIcon} alt={'иконка крестик'}/>
                </div>
                <div className="route-order-modal-main-block">
                    <div className="route-order-modal__templates-group-inputs-loading-order">
                        <div className="route-order-modal__templates-input">
                            <label>Loading order number</label>
                            <input className="route-order-modal__templates-input-loading-order"
                                   type={"text"}
                                   name={'number'}
                                   defaultValue={isRouteOrdersBodyRequest.length !== 0 ? isRouteOrdersBodyRequest[0]?.number : formik.values.name}
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                            />
                            {formik.errors.number && formik.touched.number ? <p className="route-order-modal-form-error">{formik.errors.number}</p> : null}
                        </div>
                        <div className="route-order-modal__templates-input">
                            <label>Loading order date</label>
                            <input className="route-order-modal__templates-input-loading-order"
                                   type={"date"}
                                   name={'date'}
                                   defaultValue={isRouteOrdersBodyRequest.length !== 0 ? isRouteOrdersBodyRequest[0]?.date : formik.values.name}
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                            />
                            {formik.errors.date && formik.touched.date ? <p className="route-order-modal-form-error">{formik.errors.date}</p> : null}
                        </div>
                        <div className="route-order-modal__templates-input">
                            <label>Units type</label>
                            <div className="route-order-modal__three-inputs-item-weight">
                                <select onChange={(e) => onHandleGrossWeightType(e.target.value)} className="route-order-modal__select-weight">
                                    {optionGrossWeight.map((el, i) => {
                                        return (
                                            <option value={el.value} key={i}>{el.value}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            {formik.errors.grossWeight && formik.touched.grossWeight ? <p className="route-order-modal-form-error">{formik.errors.grossWeight}</p> : null}
                        </div>
                    </div>
                    <div className="route-order-modal__templates-group-inputs-route-order">
                        <div className="route-order-modal__table-header">
                            <p>Routing instruction</p>
                            <p>Cargo declaration</p>
                            <p>Gross weight</p>
                        </div>
                        <div className="route-order-modal__table-string-instruction">
                            {formik.values.goods.length !== 0 &&
                                <>
                                {formik.values.goods.map((el, i) => {
                                    return (
                                        <div key={el.id} className="route-order-modal__table-string-items">
                                            <RoutingInstruction
                                                idItem={el.id}
                                                elemArray={el}
                                                isRouteOrdersBodyRequest={isRouteOrdersBodyRequest}
                                                formik={formik}
                                            />
                                            <CargoDeclaration
                                                idItem={el.id}
                                                elemArray={el}
                                                isRouteOrdersBodyRequest={isRouteOrdersBodyRequest}
                                                formik={formik}
                                            />
                                            <GrossWeight
                                                idItem={el.id}
                                                elemArray={el}
                                                isRouteOrdersBodyRequest={isRouteOrdersBodyRequest}
                                                formik={formik}
                                            />
                                            <img onClick={() => onHandlerDeleteGoods(el)} className="route-order-modal__table-row-icon-minus" src={minusIcon} alt={'icon'}/>
                                        </div>
                                    )
                                })}
                                </>
                            }
                            <div onClick={onHandlerAddGoods} className="route-order-modal-add-new-field__btn-add-new">
                                <img src={addPlusIcon} alt={'иконка плюс'} />
                                <p>Add routing instruction</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="route-order-modal__buttons">
                    {/*<p className="route-order-modal__buttons-message-error">{isModalMessage}</p>*/}
                    <button type={"button"} onClick={() => onCloseRouteOrderModal()} className="route-order-modal__buttons-cancel">Cancel</button>
                    <button type={"submit"} className="route-order-modal__buttons-save">Save</button>
                </div>
            </form>
        </div>
    )
}
export default RouteOrderModal;